import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-edited-field-tag',
    templateUrl: './edited-field-tag.component.html',
    standalone: true
})
export class EditedFieldTagComponent {
  @Input() previousValue!: string;
}
